import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'
import { isEmpty } from 'lodash'
import type { CustomerUser } from '@einwert/valuation-api-client'
import type { OrderListItem } from 'ClientPortal/src/pages/Orders/OrderList/OrderListPageContent.data'
import { Box, Stack } from '@mui/material'
import { ListCardInfo, tokens, UserLinkList } from 'ComponentLibrary'
import { useTranslation } from 'react-i18next'
import { useUserLinkCopy } from 'ClientPortal/src/i18n/useUserLinkCopy'

type MandatorInfoCellProps = {
    order: OrderListItem
    customerUserList: CustomerUser[]
}

export const MandatorInfoCell = ({ order, customerUserList }: MandatorInfoCellProps) => {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.orderListPage.cells' })
    const { t: tTerminology } = useTranslation('terminology', { keyPrefix: 'common' })
    const userLinkCopy = useUserLinkCopy()
    const mainMandator = order.mandators?.[0]

    const assignedTo = customerUserList.filter((customerUser) => order.assigned_customer_users.includes(customerUser.id))

    return (
        <ListCardInfo
            style={{
                width: '260px',
                padding: tokens.SizingSpacing075,
                borderRadius: tokens.SizingCornerS,
                backgroundColor: tokens.ColorSurfaceInverseDefault,
                gap: tokens.SizingSpacing025,
            }}
        >
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075} height="18px">
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {t('assignee')}
                </Typography>
                {!isEmpty(assignedTo) ? (
                    <UserLinkList users={assignedTo} size="small" maxWidth="150px" copy={userLinkCopy} />
                ) : (
                    <Typography variant="textS" color={tokens.ColorTextDisabled}>
                        -
                    </Typography>
                )}
            </Stack>
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {tTerminology('mandator')}
                </Typography>
                <Box display="flex" justifyContent="flex-end" minWidth={0} maxWidth="200px">
                    <TextWithEllipsis
                        tooltipText={mainMandator.name}
                        typographyProps={{
                            variant: 'textS',
                            color: mainMandator.name ? tokens.ColorTextBold : tokens.ColorTextDisabled,
                        }}
                    >
                        {mainMandator.name || t('notSet')}
                    </TextWithEllipsis>
                </Box>
            </Stack>
        </ListCardInfo>
    )
}
